<template>
  <!-- 公示天数 -->
  <el-dialog class="dialog-set-days" title="公示" :visible.sync="dialogVisible" width="500px">
    <div class="content">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="110px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="公示天数 :" prop="publicDays">
              <el-input v-model.number="form.publicDays"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="tr mt-30">
        <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      loadingSave: false,
      pageType: '1', // 0-取消公示 1-公示
      detailId: '',
      form: {},
      rules: {
        publicDays: [
          { required: true, message: '必填', trigger: 'blur' },
          { type: 'number', message: '必须为数字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init(id, type) {
      this.detailId = id
      this.pageType = type
      this.dialogVisible = true

      this.$nextTick(() => {
        // this.$refs['form'].resetFields()
        this.$refs['form'].clearValidate()
      })
    },
    // 保存
    fromSubmit(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post('/BsVolunteerRecruit/publicOrCancel', {
              id: this.detailId,
              status: this.pageType, // 0-取消公示 1-公示
              ...this.form
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success(
                  this.pageType === '1' ? '公示成功' : '取消公示成功'
                )
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

